<template>
    <main id="main-container" style="min-height: 669px;">
        <!-- Page Content -->
        <div class="hero bg-white">
            <div class="hero-inner">
                <div class="content content-full">
                    <div class="py-30 text-center">
                        <div class="display-3 text-danger">
                            <i class="fa fa-warning"></i> 404
                        </div>
                        <h1 class="h2 font-w700 mt-30 mb-10">Oops.. You just found an error page..</h1>
                        <h2 class="h3 font-w400 text-muted mb-50">We are sorry but the page you are looking for was not found..</h2>
<!--                        <a class="btn btn-hero btn-rounded btn-alt-secondary" href="be_pages_error_all.html">-->
<!--                            <i class="fa fa-arrow-left mr-10"></i> Back to all Errors-->
<!--                        </a>-->
                    </div>
                </div>
            </div>
        </div>
        <!-- END Page Content -->
    </main>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
